import { render, staticRenderFns } from "./Angsuran.vue?vue&type=template&id=37d61fc0&"
import script from "./Angsuran.vue?vue&type=script&lang=js&"
export * from "./Angsuran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports